import React from "react";

const VideoThumbnail = ({ videoUrl }) => {
  return (
    <div className='relative overflow-hidden'>
      <video 
        className="h-full w-full rounded-lg" 
        controls 
        autoPlay
        muted // Ajouté pour éviter les problèmes d'autoplay
      >
        <source src={videoUrl ? videoUrl : "https://docs.material-tailwind.com/demo.mp4"} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default VideoThumbnail;